import { render, staticRenderFns } from "./BillingDetail.vue?vue&type=template&id=b2210cae&scoped=true"
import script from "./BillingDetail.vue?vue&type=script&lang=js"
export * from "./BillingDetail.vue?vue&type=script&lang=js"
import style0 from "./BillingDetail.vue?vue&type=style&index=0&id=b2210cae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2210cae",
  null
  
)

export default component.exports